export default __webpack_public_path__ + "static/media/dr-bs-chandrashekar.8321ee39.jpg";